import React from 'react';

/**
 * Shared utilities for insight cards (status quo vs adjusted, change indicators).
 */

export function calculateChange(
  original: number | undefined,
  current: number | undefined
): number | null {
  if (original == null || current == null || original === 0) return null;
  return ((current - original) / original) * 100;
}

export function getChangeTintClass(
  original: number | undefined,
  current: number | undefined
): string {
  const percentChange = calculateChange(original, current);
  if (percentChange == null) return 'tint-grey';
  if (percentChange > 0.01) return 'tint-green';
  if (percentChange < -0.01) return 'tint-red';
  return 'tint-grey';
}

export function renderChangeIndicator(percentChange: number | null): React.ReactNode {
  if (percentChange == null) return null;
  if (Math.abs(percentChange) < 0.01) return null;
  const changeClass = percentChange >= 0 ? 'positive-change' : 'negative-change';
  return React.createElement(
    'div',
    { className: `change-indicator ${changeClass}` },
    (percentChange >= 0 ? '+' : '') + percentChange.toFixed(2) + '%'
  );
}
